import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Item, Empty } from '.'
import AccountStatementPlaceholder from './AccountStatementPlaceholder'
import InfiniteScroll from 'react-infinite-scroller'
import { Button } from 'loyal-react'

class AccountStatement extends Component {
  constructor (props) {
    super(props)
    this.state = {
      arrayItems: '',
      hasMoreItems: true,
      pageItem: 0,
      currentItems: ''
    }
  }

  buildItemProps = ({
    date,
    type,
    purchaseId,
    description,
    parentOrderId,
    vendorName
  }) => {
    const dateFormat = moment.utc(date).format('DD/MM/YYYY - HH:mm')
    const descriptionFormat = purchaseId
      ? `#${purchaseId} - ${description}`
      : description

    const props =
      type === 'DEBIT'
        ? {
          cssColor: 'color-error',
          subtitle: `Debitado em ${dateFormat}`,
          icon: 'remove_circle',
          description: descriptionFormat,
          parentOrderId,
          vendorName
        }
        : {
          cssColor: 'color-success',
          subtitle: `Creditado em ${dateFormat}`,
          icon: 'cash',
          description: descriptionFormat,
          parentOrderId,
          vendorName
        }
    return props
  }
  componentWillReceiveProps (nextProps) {
    if (nextProps.items.length !== this.state.currentItems.length) {
      this.setState({ arrayItems: '', hasMoreItems: true })
    }
  }
  listItems = () => {
    const { items } = this.props

    return items
  }
  loadExtract () {
    let items = this.listItems()

    if (items.length === this.state.currentItems.length) {
      this.printItems()
    } else {
      this.setState({ currentItems: items, pageItem: 0 })
      this.printItems()
    }
  }
  printItems () {
    setTimeout(() => {
      if (this.state.currentItems.length > 0) {
        this.setState({
          arrayItems: this.state.currentItems.slice(
            0,
            this.state.pageItem * 10 + 10
          )
        })
        if (this.state.arrayItems.length < this.state.currentItems.length) {
          this.setState({ pageItem: this.state.pageItem + 1 })
        } else {
          this.setState({ hasMoreItems: false })
        }
      } else {
        this.setState({ arrayItems: [], hasMoreItems: false })
      }
    }, 1000)
  }
  render () {
    if (this.props.isLoading) {
      return <AccountStatementPlaceholder />
    }

    return (
      <InfiniteScroll
        pageStart={0}
        loadMore={() => this.loadExtract()}
        hasMore={this.state.hasMoreItems}
        loader={<Button loading text='Carregando' className='btn-flat' />}
        key={10}
        initialLoad
      >
        <div className='item-content col-12 txt-font-body txt-body-sm color-ui-2 radius-bottom'>
          {this.state.arrayItems.length > 0 ? (
            this.state.arrayItems.map((item, index) => (
              <Item
                key={index}
                value={item.valuePoints}
                currency={this.props.currency}
                {...this.buildItemProps(item)}
              />
            ))
          ) : (
            <Empty />
          )}
        </div>
      </InfiniteScroll>
    )
  }
}

AccountStatement.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  items: PropTypes.array.isRequired,
  currency: PropTypes.object.isRequired,
  fetchExtract: PropTypes.func.isRequired
}

export default AccountStatement



// WEBPACK FOOTER //
// ./src/Participant/Extract/Details/AccountStatement.js